import React from "react";
import EACheckbox from "../Checkbox/EACheckbox";
import "./EATable.scss";
import useEATable from "./useEATable";
import { EATableColumn, EATableRow } from "../../../models/EATable";

interface IProps {
  columns: EATableColumn[]; // Lista kolumn
  data: EATableRow[]; // Dane do wyświetlenia
  className?: string; // Opcjonalna klasa CSS dla niestandardowych stylów
  selection?: boolean; // Opcjonalna możliwość zaznaczenia wierszy
  onSelectionChange?: (selectedRows: EATableRow[]) => void; // Funkcja zwrotna dla zmian zaznaczenia
  noDataLabel?: string; // Opcjonalny komunikat gdy brak danych
}

const EATable: React.FC<IProps> = ({
  columns,
  data,
  className,
  selection = false,
  onSelectionChange = () => {},
  noDataLabel = "Brak danych",
}) => {
  const { renderCellValue, handleCheckboxChange, selectedRows, selectAll, setSelectAll } = useEATable(
    data,
    onSelectionChange
  );

  return (
    <div className={`custom-table__container ${className}`}>
      <table className="custom-table__table">
        <thead>
          <tr>
            {selection && (
              <th className="custom-table__selection-column">
                <EACheckbox name="table-select-all-checkbox" checked={selectAll} onChange={setSelectAll} />
              </th>
            )}
            {columns.map((col: EATableColumn) => (
              <th key={col.key} style={{ textAlign: col.align || "left", width: col.width }}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length + (selection ? 1 : 0)} style={{ textAlign: "center" }}>
                {noDataLabel}
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr key={rowIndex} className={selectedRows.has(rowIndex) ? "custom-table__selected-row" : ""}>
                {selection && (
                  <td>
                    <EACheckbox
                      name={`table-select-checkbox-${rowIndex}`}
                      checked={selectedRows.has(rowIndex)}
                      onChange={() => handleCheckboxChange(rowIndex)}
                    />
                  </td>
                )}
                {columns.map((col: EATableColumn) => (
                  <td key={col.key} style={{ textAlign: col.align || "left", width: col.width }}>
                    {col.render ? col.render(row[col.key], row, rowIndex) : renderCellValue(row[col.key], col.type)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EATable;
